import { render, staticRenderFns } from "./PreInicio.vue?vue&type=template&id=bd1c185c&"
import script from "./PreInicio.vue?vue&type=script&lang=js&"
export * from "./PreInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports